module.exports = __webpack_public_path__ + "img/079.8b2b57c4.png";